(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/page-category-games-standalone.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/page-category-games-standalone.js');

'use strict';

const {
  useEffect
} = React;
const ErrorPage = svs.components.casino_react.page_error;
const {
  GridDisplayModes
} = svs.components.casino_react.common.constants;
const {
  CasinoSection
} = svs.components.casino_react.casinoSection;
const {
  setMetaTags
} = svs.components.lbUtils.setMetaTags;
const {
  SubHeader
} = svs.components.casino_react.sub_header;
const {
  useSearchResults
} = svs.components.casino_react.casinoStore.hooks;
const {
  useSetSearchParams,
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  FilterAndSort
} = svs.components.casino_react.filterAndSort;
const actionButtons = () => React.createElement(FilterAndSort, null);
const PageCategoryGamesStandalone = _ref => {
  let {
    currentCategory,
    renderSubHeader
  } = _ref;
  const {
    setListIds
  } = useSetSearchParams();
  const {
    listIds
  } = useSearchParams();
  useEffect(() => {
    if (currentCategory.contentList && listIds.length === 0) {
      setListIds([currentCategory.contentList]);
    }
  }, [currentCategory.contentList, listIds, setListIds]);
  const {
    games,
    error,
    isLoading,
    totalGamesCount
  } = useSearchResults();
  useEffect(() => {
    setMetaTags({
      docTitle: currentCategory.metaTitle,
      metaDesc: currentCategory.metaDescription
    });
  }, [currentCategory.metaTitle, currentCategory.metaDescription]);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  return React.createElement(React.Fragment, null, renderSubHeader && React.createElement(SubHeader, {
    title: currentCategory.name
  }), React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    isLoading: isLoading,
    isSearchResult: (games === null || games === void 0 ? void 0 : games.length) === 0,
    isVirtualized: true,
    items: games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.PageCategoryGamesStandalone', PageCategoryGamesStandalone);

 })(window);